/*
 * PDE - JavaScript
 * Copyright 2010. All rights reserved.
 *
 * Class: Blimp
 * Description: Calls and loads popup content into the page
 */

var Blimp = new Class({
	Implements: [Options, Apos, Events],
	options: {
		cls: 'w_popup',
		off_x: 0,
		off_y: 0,
		loader: false,
		loader_x: 0,
		popup_x: null,
		draggable: false,
		animation: true
	},

	initialize: function(link, options) {
		this.setOptions(options);
		this._link = link;
		this.opts = this.options;
		this.draggable = this.options.draggable;

		if(this._link) {
			this.state = false;
			this.build();
		}
	},

	setTrigger: function(link) {
		this._trigger = link;
	},

	build: function() {
		if(this._link.hasClass('g_direct')) return;

		var self = this;
		this.make_link();

		this.addEvents({
			show: function() {
				self.removeTabbingRestriction = Core.disableTabbingOutside(self._element);
				setTimeout(() => self.focusOnCloseOrFirst(), 100);
				self._element.setAttribute('aria-label', 'modal dialog');
				self._element.setAttribute('role', 'region');
			},
			hide: function() {
				self.removeTabbingRestriction && self.removeTabbingRestriction();
				self.removeTabbingRestriction = null;
				// when modal is dismissed, focus back on the toggle element
				// sometimes self._link is not really the trigger of this popup
				// for example in crphotogallerylink.js
				// in that case _trigger will be manually set
				// if(self._trigger) {
				// 	return self._trigger.focus();
				// }
				// if(self._link)
				// 	self._link.focus();
			}
		})
	},

	focusOnCloseOrFirst: function() {
		const closeDom = this._element.querySelector('.w_popup_close');
		if(closeDom)
			return closeDom.focus();
		const tabElements = this._element.querySelectorAll('a, button, input');
		tabElements[0] && tabElements[0].focus();
	},

	make_link: function() {
		this._link.removeEvents('click').addEvent('click', this.handle_link_click.bind(this));
	},

	handle_link_click: function(e) {
		if (e && e.stop) e.stop();

		if (e && e.preventDefault) e.preventDefault();

		if (this.opts.loader) {
			this.loader = new Loader(this._link, { off: {x: this.opts.loader_x}, hasSpan: false, cls: 'w_loader_facebook'});
		}
		this.fireEvent('fetch', [this, this._link]);
		this.fetch(this.retrieve_url());
	},

	retrieve_url: function() {
		var url = this._link.get('data-rpc') || this._link.get('href');
		if(!url){
			return;
		}
		first_char = url.substring(0, 1);
		if (first_char == '#'){
			url = url.substring(1, url.length);
			this._link.set('href', url);
		}
		return url;
	},

	fetch: function(location) {
		if(this.loader) {
			this.loader.plus();
		}

		if(this.request) {
			this.request.cancel();
		}
		this.request = new Request.JSON({
			url: location,
			noCache: true,
			onSuccess: function(data) {
				this.get_data(data);
			}.bind(this)
		}).get();
	},

	add_signup_links: function() {
		if (this.content) {
			var elements = this.content.getElements('.reg_blimp');
			for (var i = 0; i < elements.length; i++) {
				Core.add_signup_link(elements[i]);
			}
		}
	},

	get_data: function(data){
		this.data = data;

		if (this.options.get_content) {
			this.content = this.options.get_content(this, data);
		} else {
			this.content = (new Element('div', {'html': data.content})).getFirst().dispose();
		}

		this.process();
	},

	process: function() {
		this._element = this.content;

		this.build_toggle();
		this.build_close();
		if (this.draggable) {
			this.build_draggable();
		} else {
			 this.find_position();
		}
		this.post_process();
	},

	center_popup: function(){
		var win_scroll = window.getScroll();
		var win_size = window.getSize();
		var el_size = this._element.getSize();
		var pos_y = this.positionY = win_scroll.y + Math.floor(Math.max(0, (win_size.y - el_size.y)/2));
		var pos_x = this.positionX = win_scroll.x + Math.floor(Math.max(0, (win_size.x - el_size.x)/2));

		this._element.setStyles({
			position: 'absolute'
		});

		if(this.options.animation){
			 if(!this.fx){
					this.fx = new Fx.Morph(this._element, {link: 'cancel', transition: 'back:out', duration: 0});
					this.fx.set({
						 'top': pos_y,
						 'left': pos_x
					});
			 }else{
				 this.fx.start({
						 'top': pos_y,
						 'left': pos_x
					});
			 }
		}else{
			this._element.setStyles({
				 top: pos_y,
				 left: pos_x
			 });
		}
	},

	build_draggable: function () {
		this.disableScroll();
		var drag_instance =
		this.drag_instance = new Drag(this._element, {
			handle: this._element.getElement('.'+this.options.cls+'_header'),
			onBeforeStart: function(el){
				var win_size = window.getSize(),
						body_size = document.id(document.body).getScrollSize(),
						el_size = el.getSize(),
						lim = {
										x: [0, win_size.x - el_size.x],
										y: [0, body_size.y - el_size.y]
									};
				drag_instance.setOptions({
					 limit: lim
				});
			},

			onSnap: function(el){
				el.addClass('_dragging');
				this.fireEvent('onSnap', this);
			}.bind(this),

			onComplete: function(el){
				el.removeClass('_dragging');
				this.fireEvent('onComplete', this);
			}.bind(this)
		});
	},

	build_toggle: function() {
		this._link.removeEvents('click').addEvent('click:once', function(e) {
			if(e && e.stop) e.stop();
			this.toggle();
		}.bind(this));
	},

	build_close: function() {
		this.close = this._element.getElement('.'+this.opts.cls+'_close');
		if (this.close) {
			this.close.removeEvents().addEvent('click', function(e) {
				if(e && e.stop) e.stop();
				this.enableScroll();
				this.hide();
			}.bind(this));
		}
	},

	disableScroll: function() {
		document.querySelector('html').addClass('no-scroll');
	},

	enableScroll: function() {
		document.querySelector('html').removeClass('no-scroll');
	},

	find_position: function() {
		if(this.options.get_content){
			return;
		}
		// calculate where to position the popup
		this.positionY = this._link.getCoordinates().top + this.opts.off_y;
		this.positionX = this._link.getCoordinates().left + this.opts.off_x;
		var window_split = window.getSize().x / 2;
		if(this.positionX < window_split) {
			var off_x = this.positionX;
			this.linkX = 0;

		} else {
			var link_width = this._link.getSize().x;
			off_x = this.positionX - this.opts.popup_x + link_width + this.opts.off_x;
			this.linkX = (this.opts.popup_x - link_width - this.opts.off_x) * -1;
		}
		this.positionX = off_x;
		this.set_position();
	},

	set_position: function() {
		this._element.setStyles({
			position: 'absolute',
			top: this.positionY,
			left: this.positionX
		});

		this.setHook(this._link);
		this.setApos(this._element, {x: this.opts.off_x, y: this.opts.off_y});
	},

	show: function() {
		if (this.data) {
			this.implement_tracking(this.data);
		}

		this._element.removeClass(Gv.cloak);
		this._element.removeClass(Gv.hidden);

		this.state = true;

		if(this.draggable && !this.options.get_content)
			this.center_popup();

		if(this.options.show_veil)
			this.handle_self_show();

		this.fireEvent('show', [this]);
	},

	hide: function() {
		if(this._element) {
			this._element.addClass(Gv.cloak);
			this._element.addClass(Gv.hidden);

			this.state = false;
			this.fireEvent('hide', [this]);

			if(this.options.show_veil)
				this.handle_self_hide();
		}
	},

	toggle: function() {
		if(this.state) {
			this.hide();
		} else {
			this.show();
		}
	},

	post_process: function() {
		if(!this.content.getParent()){
			this.inject(this.content);
			if(this.options.show_veil){
				this.content.addClass('_has_veil');
			}
		}

		if(this.loader) {
			this.loader.minus();
		}

		if(this.options.show_veil) {
			this.build_veil();
		}

		this.show();
	},

	inject: function(content){
		content.inject(document.id(document.body));
	},

	build_veil: function(){
	 var cls = this.options.cls;
	 this._veil = this._element.getPrevious('.'+cls+'_veil') || this._element.getNext('.'+cls+'_veil') || new Element('div');
	},

	handle_self_show: function(){
	 this._veil.show();
	 this._veil.setStyles({
		 width: 'auto',
		 height: 'auto'
	 });
	 var b_scroll = document.id(document.body).getScrollSize();
	 this._veil.setStyles({
		 'width': b_scroll.x,
		 'height': b_scroll.y
	 });
	},

	handle_self_hide: function(){
		this._veil.hide();
	},

	implement_tracking: function(data, submit) {
		if(data && data.tracking) {
			new Tracking(data.tracking, submit);
		}
	}
});
